import { render } from "./BaseWithoutLineModal.vue?vue&type=template&id=4f15c2ca"
import script from "./BaseWithoutLineModal.vue?vue&type=script&lang=js"
export * from "./BaseWithoutLineModal.vue?vue&type=script&lang=js"
script.render = render

export default script